// GET_CONSENT

const initState = {
  orders: [],
  lastDoc: null,
  hasMoreOrders: true,
  isFetchingOrders: false,
  error: null,
};

const orderReducer = (state = initState, action) => {
  switch (action.type) {
    case "FETCH_ORDERS_PENDING":
      return {
        ...state,
        isFetchingOrders: true,
        error: null,
      };
    case "FETCH_ORDERS_SUCCESS":
      return {
        ...state,
        orders: action.payload.orders,
        lastDoc: action.payload.lastDoc,
        hasMoreOrders: action.payload.hasMoreOrders,
        isFetchingOrders: false,
      };
    case "FETCH_ORDERS_LOAD_MORE_SUCCESS":
      return {
        ...state,
        orders: [...state.orders, ...action.payload.orders],
        lastDoc: action.payload.lastDoc,
        hasMoreOrders: action.payload.hasMoreOrders,
        isFetchingOrders: false,
      };
    case "FETCH_ORDERS_REJECTED":
      return {
        ...state,
        isFetchingOrders: false,
        error: action.error,
      };
    default:
      return {
        ...state,
      };
  }
};
export default orderReducer;
